export enum QualityCdEnum {
  '0 - Trash',
  '1 - Bad',
  '2 - Average',
  '3 - Good',
  '4 - Very Good',
  '5 - Best'
}
